import React, {Component} from 'react';
import {Field} from "redux-form";
import BranchAccessForm from './BranchAccessForm';
import BranchPicker from './BranchPicker';

export default class BranchSelectorInput extends Component {

    field = (props) => {

        const {input} = props; // input is the existing useraccess list for the user

        const onUserAccessAddClicked = (useraccess) => {
            const arr = [...input.value];
            useraccess.deleteable = true;
            arr.push(useraccess);
            return input.onChange(arr);
        };

        const onUserAccessDeleteClicked = (useraccess) => {
            const arr = input.value.filter((b)=>b.branchId !== useraccess.branchId ||
                                                b.customerId !== useraccess.customerId ||
                                                b.countryCode !== useraccess.countryCode ||
                                                b.groupId !== useraccess.groupId);
            return input.onChange(arr);
        };

        return (
            <div>
                <BranchPicker filter={(b)=>{return b}} onUserAccessAddClicked={onUserAccessAddClicked} resetSearch={props.resetSearch}/>
                <BranchAccessForm useraccess={input.value} onUserAccessDeleteClicked={onUserAccessDeleteClicked}/>
            </div>
        );
    };

    render() {
        return <Field {...this.props} component={this.field} />;
    }
}


// WEBPACK FOOTER //
// ./src/components/branchSelector/BranchSelectorInput.js